import type { CSSProperties } from "react";

export interface ShareIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
  style?: CSSProperties;
}

/**
 * iOS-style share glyph (square tray with arrow rising out of its open top).
 * Aligned to the iOS 26 "Liquid Glass" share symbol: thin uniform stroke,
 * rounded line joins, open top with the line + chevron protruding upward.
 *
 * Stroke-only, uses currentColor so it inherits text colour — matches the
 * grayscale-only design system (no fills introduced).
 */
export function ShareIcon({
  size = 48,
  color = "currentColor",
  strokeWidth = 1.5,
  style,
}: ShareIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      style={style}
    >
      {/* Tray: rounded rect with an opening at the top centre for the line
          to pass through. Drawn as two arcs joined by the bottom + sides. */}
      <path d="M9.25 9 H6 a2.25 2.25 0 0 0 -2.25 2.25 V19.5 a2.25 2.25 0 0 0 2.25 2.25 H18 a2.25 2.25 0 0 0 2.25 -2.25 V11.25 A2.25 2.25 0 0 0 18 9 H14.75" />
      {/* Vertical stem: from inside the tray (y≈15) up past the top edge to
          the arrow apex (y≈3). */}
      <path d="M12 15 V3" />
      {/* Chevron at apex. */}
      <path d="M7.75 7.25 L12 3 L16.25 7.25" />
    </svg>
  );
}
